/** Количество фотогафий  */
export const PAGE_SIZE = 30;
